import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "layout bg-white" }
const _hoisted_2 = { class: "w-full py-2 md:py-3 px-4 md:px-6" }
const _hoisted_3 = { class: "text-lg md:text-2xl font-bold text-black leading-tight" }
const _hoisted_4 = {
  key: 0,
  class: "mt-0.5 md:mt-1 text-xs md:text-sm text-black"
}

import type { PageHeaderProps } from '@/types/ui'


export default /*@__PURE__*/_defineComponent({
  __name: 'PageHeader',
  props: {
    title: {},
    subtitle: {},
    showExport: { type: Boolean, default: false },
    showSave: { type: Boolean, default: false },
    stackUntilXl: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(['flex items-start justify-between', _ctx.stackUntilXl && 'md:flex-col md:gap-3 xl:flex-row xl:gap-0'])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(['flex-1 min-w-0', _ctx.stackUntilXl && 'md:w-full xl:w-auto'])
        }, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _renderSlot(_ctx.$slots, "subtitle", {}, () => [
            (_ctx.subtitle)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.subtitle), 1))
              : _createCommentVNode("", true)
          ])
        ], 2),
        (_ctx.$slots.extra)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['flex items-center gap-3 relative z-10 mt-0.5 md:mt-1', _ctx.stackUntilXl && 'md:w-full xl:w-auto'])
            }, [
              _renderSlot(_ctx.$slots, "extra")
            ], 2))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}
}

})